/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

export const LabelDecorator = props => (
  <div className="form-group">
    <label className="control-label col-sm-5">{props.label}</label>
    <div className="col-sm-7">
      {props.children}
    </div>
  </div>);

LabelDecorator.propTypes = {
  label: PropTypes.string,
  children: PropTypes.element.isRequired,
};

LabelDecorator.defaultProps = {
  label: '',
};
